class DB {
  constructor() {
    this.dbName = 'oripay';
    this.storeName = 'data';
    this.db = null;
  }

  // Membuka atau membuat database
  openDatabase() {
    return new Promise((resolve, reject) => {
      if (this.db) {
        resolve(this.db);
        return;
      }

      const request = indexedDB.open(this.dbName, 1);

      request.onupgradeneeded = (event) => {
        const db = event.target.result;
        if (!db.objectStoreNames.contains(this.storeName)) {
          db.createObjectStore(this.storeName, { keyPath: 'id' });
        }
      };

      request.onsuccess = (event) => {
        this.db = event.target.result;
        resolve(this.db);
      };

      request.onerror = (event) => {
        console.error('IndexedDB open error:', event.target.error);
        reject(event.target.error ? event.target.error : 'Unknown error during database open');
      };
    });
  }

  // Menyimpan data
  save(id, data) {
    return this.openDatabase().then(() => {
      return new Promise((resolve, reject) => {
        const transaction = this.db.transaction([this.storeName], 'readwrite');
        const store = transaction.objectStore(this.storeName);
        const request = store.put({ id, data });

        request.onsuccess = () => {
          resolve('Data saved successfully!');
        };

        request.onerror = (event) => {
          console.error('Save error:', event.target.error);
          reject(event.target.error ? event.target.error : 'Unknown save error');
        };
      });
    });
  }

  // Mengambil data
  get(id) {
    return this.openDatabase().then(() => {
      return new Promise((resolve, reject) => {
        const transaction = this.db.transaction([this.storeName], 'readonly');
        const store = transaction.objectStore(this.storeName);
        const request = store.get(id);

        request.onsuccess = () => {
          const result = request.result;
          resolve(result ? result.data : null);
        };

        request.onerror = (event) => {
          console.error('Get error:', event.target.error);
          reject(event.target.error ? event.target.error : 'Unknown get error');
        };
      });
    });
  }

  // Menghapus data
  delete(id) {
    return this.openDatabase().then(() => {
      return new Promise((resolve, reject) => {
        const transaction = this.db.transaction([this.storeName], 'readwrite');
        const store = transaction.objectStore(this.storeName);
        const request = store.delete(id);

        request.onsuccess = () => {
          resolve('Data deleted successfully!');
        };

        request.onerror = (event) => {
          console.error('Delete error:', event.target.error);
          reject(event.target.error ? event.target.error : 'Unknown delete error');
        };
      });
    });
  }

  clear() {
    return this.openDatabase().then(() => {
      return new Promise((resolve, reject) => {
        const transaction = this.db.transaction([this.storeName], 'readwrite');
        const store = transaction.objectStore(this.storeName);
        const request = store.clear();

        request.onsuccess = () => {
          resolve('All data cleared successfully!');
        };

        request.onerror = (event) => {
          console.error('Clear error:', event.target.error);
          reject(event.target.error ? event.target.error : 'Unknown clear error');
        };
      });
    });
  }
}

export default new DB();
